export const createTraineeTask = (payload?: any) => ({
    type: "@saga/CREATE_TRAINEE_TASK",
    payload
});

